import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';

import { filter } from 'rxjs/operators';

import { LoaderComponent } from './portal/components/loader/loader.component';
import { NetworkService } from './portal/services/network.service';
import { CommonModule } from '@angular/common';
import { CookiesConsentComponent } from './common/cookies-consent/cookies-consent.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    LoaderComponent,
    CommonModule,
    CookiesConsentComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title: string = 'web.app.jnardc';
  visitorCount: number = 0;
  isOnline = navigator.onLine;
  showOnlineMessage = false;
  private hasLoaded = false;
  constructor(
    private router: Router,
    private networkService: NetworkService,
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

  ngOnInit() {
    this.updateVisitorCount();
    this.networkService.online$.subscribe((online) => {
      this.isOnline = online;

      if (online && this.hasLoaded) {
        this.showOnlineMessage = true;
        setTimeout(() => {
          this.showOnlineMessage = false;
        }, 3000);
      }

      if (!this.hasLoaded) {
        this.hasLoaded = true;
      }
    });
  }

  retryConnection() {
    window.location.reload();
  }
  // This approach tracks unique visitors over time (e.g., count once per 24 hours).
  updateVisitorCount() {
    const lastVisit = localStorage.getItem('lastVisit');
    const now = new Date().getTime();
    const oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    if (!lastVisit || now - parseInt(lastVisit, 10) > oneDay) {
      // Get visitor count
      const count = localStorage.getItem('visitorCount');
      this.visitorCount = count ? parseInt(count, 10) + 1 : 1;

      // Update count in localStorage
      localStorage.setItem('visitorCount', this.visitorCount.toString());

      // Update last visit timestamp
      localStorage.setItem('lastVisit', now.toString());
    } else {
      // If within 24 hours, just get the existing count
      const count = localStorage.getItem('visitorCount');
      this.visitorCount = count ? parseInt(count, 10) : 0;
    }
  }
}
